import React, { Component } from 'react';
import ReactModal from 'react-modal';
import RoundButton from 'components/ui/roundButton';
import breakpoints from 'constants/breakpoints';
import './modal.scss';

interface Props {
  isOpened: boolean;
  onClickAwayClose: boolean;
  customClassName?: string;
  needCloseButton?: boolean;
  tooltipId?: string;
  modalId: string;
  theme: string;
  onClose: () => void;
}

class Modal extends Component<Props> {
  render() {
    const {
      isOpened,
      modalId,
      theme,
      onClose,
      onClickAwayClose,
      customClassName = '',
      needCloseButton,
    } = this.props;

    return (
      <ReactModal
        isOpen={isOpened}
        ariaHideApp={false}
        onRequestClose={() => {
          if (onClickAwayClose) {
            onClose();
          }
        }}
        className={`react-modal-portal modal modal-${modalId} ${
          theme ? `modal_${theme}` : ''
        } ${customClassName}`}
        overlayClassName='modal-overlay'
        contentLabel='Modal'>
        {needCloseButton ? (
          <RoundButton
            icon='im-Close'
            iconSize={10}
            size={window.innerWidth > breakpoints.panels ? 30 : 24}
            customClass='modal__close'
            onClick={() => onClose()}
          />
        ) : null}

        <div className='modal__inner'>{this.props.children}</div>
      </ReactModal>
    );
  }
}

export default Modal;
